export default {"src":"/_next/static/media/addressMapPin.60573f9c.svg","height":313,"width":500,"blurWidth":0,"blurHeight":0};